export enum AddressMode {
  CONFIRM = 'CONFIRM',
  AUTOCOMPLETE = 'AUTOCOMPLETE',
  EDIT = 'EDIT',
  MANUAL = 'MANUAL',
}
